<template>
  <div class="box">
    <div class="text">
         <vuescroll :ops="ops">
            <div  class="content">
                <p>CME charges different fees for Subscribers, depending on whether they qualify as Professional Subscribers or Non Professional Subscribers.</p>
                <p style="margin-top:12px">Non-Professional shall mean and include either (i) an individual, natural person Subscriber(s) who, or (ii) certain small business entities (limited liability companies, partnerships, trusts or corporations) that, receive and use Information (excluding any pit traded data), in each case subject to the following restrictions:</p>
                <h5>The Non-Professional Subscriber must: </h5>
                <p>a) have an active futures trading account; and</p>
                <p>b) be an individual, natural person or a small business entity </p>
                <h5>The Non-Professional Subscriber must not: </h5>
                <p>c) be a member (or hold or lease any type membership) of any exchange;</p>
                <p>d) be registered or qualified as a professional trader or investment adviser with any stock, commodities or futures exchange or contract market, or with any financial regulatory authority </p>
                <p>e) be acting on behalf of an institution that engages in brokerage, banking, investment, or financial activities </p>
                <h5>The Non-Professional Subscriber's Use of Information must: </h5>
                <p>f) be solely for the Subscriber's personal or private use;</p>
                <p>g) be limited to managing the Subscriber's own assets,and not be used in connection with the management of any assets of any third party(ies) in any capacity. </p>
                <h5>The Non-Professional Subscriber's Access to Information must only:  </h5>
                <p>h) be via a maximum of two trading terminals per Distributor, permissioned for Real-Time Information and capable of routing orders to the CME Globex Platform (an“Order Routing Device”)</p>
                <p style="margin-top:12px">Any Subscriber that does not meet the qualifications of a Non-Professional Subscriber will be considered a Professional Subscriber.</p>
                <p>Notwithstanding anything herein, CME reserves the right in all cases to make a final determination as to whether a Subscriber is a Non-Professional or a Professional.</p>
            </div>
        </vuescroll>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            ops: {
                bar: {
                 background: "#c7d0e1",
                 onlyShowBarOnScroll:false,
                 keepShow:true,
                },

            },
        }
    }
}
</script>

<style scoped>
.box {
    border: 1px solid #869bc6;
    border-radius: 10px;
    background: #f9faff;
}
.text {
    width: 447px;
    height: 458px;
    color: #193f63;
    /* overflow: hidden; */
}
.content {
    padding: 20px;
    font-size: 12px;
}
.text p {
    line-height: 21px;
}
.text h5{
    font-weight: bold;
    line-height: 21px;
    margin-top: 12px;
}
</style>